(function() {
  // Sets trace id what ajax calls will use to identify which page
  // request they belong to
  var traceId = $('meta[itemprop=trace-id]').attr('content');
  MW.functions.traceId = function(id) {
    if (Array.prototype.slice.apply(arguments).length > 0) { traceId = id; }
    return traceId;
  };

  // A wrapper for jQuery.ajax() that always includes a X-HP-Trace-ID
  // header with the request.
  jQuery.ajaxTraced = function(url, options) {
    if (typeof url === 'object') {
      options = url;
    } else {
      options = options || {};
      options.url = url;
    }
    options.headers = options.headers || {};
    options.headers["X-HP-Trace-ID"] = traceId;
    return $.ajax(options);
  };
})();